import { LockOutlined, UserOutlined } from '@ant-design/icons'
import { Button, Form, Input } from 'antd'
import { APP_ID, DATE_TIME_FORMAT, DEVICE_UUID, MAGAZINE_VIEW_LOG, STORAGE_TOKEN_KEY, STORAGE_USER } from 'configs/constant'
import { HOME } from 'configs/path'
import dayjs from 'dayjs'
import { useAppDispatch, useAppSelector } from 'hooks'
import FooterPC from 'layouts/components/footer/FooterPC'
import HeaderPC from 'layouts/components/header/HeaderPC'
import { LoginPayload, LoginResponse } from 'models/auth'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'
import { apiLogDevice } from 'services/appService'
import { login } from 'services/authService'
import { bindParams } from 'utilities/helpers'
import { notifyError } from 'utilities/notification'
import { setAppId } from '../../redux/slices/appSlice'
import './Login.scss'
import ModalPolicy from './ModalPolicy'
import { Helmet } from 'react-helmet'

const LoginPage = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { app } = useParams()
  const dispatch = useAppDispatch()
  const [form] = Form.useForm()
  const { app_id, setting } = useAppSelector((s) => s.app)
  const onFinish = async (values: LoginPayload) => {
    try {
      const response: LoginResponse = await login({
        ...values,
        app_id,
        device_token: localStorage.getItem(DEVICE_UUID) || ''
      })
      if (response.success) {
        localStorage.setItem(STORAGE_TOKEN_KEY, response.data.access_token)
        localStorage.setItem(STORAGE_USER, String(response.data.user_id))

        const viewLog = JSON.parse(localStorage.getItem(MAGAZINE_VIEW_LOG) || '[]')
        const viewLogOfApp = viewLog.filter((appView: any) => Object.keys(appView)[0] === `${app_id}_${response.data.user_id}`)
        const viewLogOfOtherApp = viewLog.filter((appView: any) => Object.keys(appView)[0] !== `${app_id}_${response.data.user_id}`)

        if (viewLogOfApp.length && !!viewLogOfApp[0][`${app_id}_${response.data.user_id}`]) {
          localStorage.setItem(
            MAGAZINE_VIEW_LOG,
            JSON.stringify([
              ...viewLogOfOtherApp,
              {
                [`${app_id}_${response.data.user_id}`]: true
              }
            ])
          )
        } else {
          localStorage.setItem(
            MAGAZINE_VIEW_LOG,
            JSON.stringify([
              ...viewLogOfOtherApp,
              {
                [`${app_id}_${response.data.user_id}`]: false
              }
            ])
          )
        }
        await apiLogDevice({
          digital_id: response.data.user_id,
          login_time: dayjs().format(DATE_TIME_FORMAT),
          browser: window.navigator.userAgent,
          device_name: window.navigator.platform,
          os_version: window.navigator.appVersion
        })
        navigate(
          bindParams(HOME, {
            app: app
          })
        )
      } else {
        notifyError({ message: response.data.error?.error_message })
      }
    } catch (e) {
      notifyError({ message: 'Something went wrong' })
    }
  }

  // const onFinishFailed = (values: any) => {
  //   if (values?.errorFields.length > 0) {
  //     notifyError({ message: t('required') })
  //   }
  // }

  useEffect(() => {
    if (app) {
      dispatch(setAppId(app))
      localStorage.setItem(APP_ID, app)
    }
  }, [app])

  return (
    <>
      <Helmet>
        <title>{!!setting?.app_name && setting?.app_name}</title>
      </Helmet>
      <HeaderPC hideAction={true} hideSearch={true} />
      <div className="login_page_container">
        <Form form={form} name="login-form" className="login-form" layout="vertical" onFinish={onFinish} autoComplete="off">
          <Form.Item label={t('user_id')} name="digital_name">
            <Input prefix={<UserOutlined className="site-form-item-icon" />} placeholder={t('user_id')} />
          </Form.Item>
          <Form.Item label={t('password')} name="password">
            <Input.Password prefix={<LockOutlined className="site-form-item-icon" />} type="password" placeholder={t('password')} />
          </Form.Item>

          <Form.Item>
            <Button type="primary" htmlType="submit" className="login-form-button">
              {t('login')}
            </Button>
          </Form.Item>
        </Form>
        <ModalPolicy />
      </div>
      <FooterPC />
    </>
  )
}

export default LoginPage
